import React from 'react';
import PropTypes from 'prop-types';

const ToastInfo = ({ color = '#00A8BE' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill={color} fillRule="evenodd" transform="translate(1 1)">
            <path
                fillRule="nonzero"
                d="M9,18.5 C3.75329488,18.5 -0.5,14.2467051 -0.5,9 C-0.5,3.75329488 3.75329488,-0.5 9,-0.5 C14.2467051,-0.5 18.5,3.75329488 18.5,9 C18.5,14.2467051 14.2467051,18.5 9,18.5 Z M9,17.5 C13.6944204,17.5 17.5,13.6944204 17.5,9 C17.5,4.30557963 13.6944204,0.5 9,0.5 C4.30557963,0.5 0.5,4.30557963 0.5,9 C0.5,13.6944204 4.30557963,17.5 9,17.5 Z"
            />
            <path d="M9.83115387,13.7000122 L8.2886734,13.7000122 L8.2886734,6.83184814 L9.83115387,6.83184814 L9.83115387,13.7000122 Z M8.19345856,5.04815674 C8.19345856,4.81117639 8.26857174,4.61440101 8.41880035,4.45782471 C8.56902897,4.3012484 8.78378919,4.22296143 9.06308746,4.22296143 C9.34238573,4.22296143 9.55820389,4.3012484 9.7105484,4.45782471 C9.86289291,4.61440101 9.93906403,4.81117639 9.93906403,5.04815674 C9.93906403,5.2809053 9.86289291,5.47450688 9.7105484,5.62896729 C9.55820389,5.78342769 9.34238573,5.86065674 9.06308746,5.86065674 C8.78378919,5.86065674 8.56902897,5.78342769 8.41880035,5.62896729 C8.26857174,5.47450688 8.19345856,5.2809053 8.19345856,5.04815674 Z" />
        </g>
    </svg>
);

ToastInfo.propTypes = {
    color: PropTypes.string,
};

export default ToastInfo;
